/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS43MSAyLjAwMDAxTDExIDEuMjkwMDFMNC4yODk5OCA4LjAwMDAxTDExIDE0LjcxTDExLjcxIDE0TDUuNzA5OTggOC4wMDAwMUwxMS43MSAyLjAwMDAxWiIgZmlsbD0iaW5oZXJpdCIvPg==";